import { CHART_TYPES } from '../Charts/chartConfig'

export function chartColors(theme, questionResult) {
  return theme?.hasOneColor
    ? [theme?.colors[0]]
    : theme?.colors || defaultTheme(questionResult)
}

export function defaultTheme(questionResult) {
  const defaultTheme = ['#AC92EB', '#4FC1E8', '#A0D568', '#FFCE54', '#ED5564']

  const isWordCloud = questionResult.resultType === CHART_TYPES.WORD_CLOUD

  const resultsLength = questionResult?.results.length

  if (resultsLength <= defaultTheme.length || isWordCloud) return defaultTheme

  const amountOfExtraColors = resultsLength - defaultTheme.length

  const extraColors = Array.from({ length: amountOfExtraColors }, getRandomColor)

  return [...defaultTheme, ...extraColors]
}

function getRandomColor() {
  const maxColorValue = 16777215

  const randomColor = Math.floor(Math.random() * maxColorValue).toString(16)

  return `#${randomColor}`
}
